import { Video, MapPin } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const STEPS = [
    { n: "01", title: "Ci chiami o ci scrivi", desc: "Una telefonata o un messaggio WhatsApp. Ci racconti cosa non va: la materia, il voto, l'obiettivo." },
    { n: "02", title: "Prima lezione gratuita", desc: "Un'ora intera sul tuo programma, gratis. Se va bene, si continua. Se va male, arrivederci: non ci devi niente. Il rischio è tutto nostro." },
    { n: "03", title: "Piano su misura", desc: "Una o due lezioni a settimana, online in videochiamata o a domicilio. Orari flessibili, anche la sera." },
    { n: "04", title: "Si vedono i risultati", desc: "Esercizi mirati prima di ogni verifica. L'obiettivo è uno solo: che tu non abbia più bisogno di noi." },
];

const Method = () => (
    <section id="metodo" className="relative py-32 sm:py-40 border-t border-slate-800">
        <div className="max-w-[1440px] mx-auto px-6 sm:px-10">
            <SectionHeading
                index="03"
                label="Come funziona"
                title={
                    <>
                        Quattro passi, <em className="text-sky-400">zero burocrazia.</em>
                    </>
                }
            />

            <div className="mt-16 space-y-0">
                {STEPS.map((s, i) => (
                    <Reveal key={s.n} delay={i * 0.08}>
                        <div
                            data-testid={`method-step-${i}`}
                            className="group grid sm:grid-cols-[160px_1fr] gap-6 items-start border-t border-slate-800 py-12 hover:bg-[#0F172A]/40 transition-colors duration-500 px-4 sm:px-6"
                        >
                            <span className="font-mono text-6xl sm:text-7xl text-slate-800 group-hover:text-sky-400/70 transition-colors duration-500 leading-none">
                                {s.n}
                            </span>
                            <div>
                                <h3 className="font-serif text-2xl sm:text-3xl text-slate-50">{s.title}</h3>
                                <p className="mt-3 max-w-2xl text-slate-400 leading-relaxed">{s.desc}</p>
                            </div>
                        </div>
                    </Reveal>
                ))}
                <div className="border-t border-slate-800" />
            </div>

            <div className="mt-16 grid sm:grid-cols-2 gap-8 lg:gap-12">
                <Reveal>
                    <div data-testid="mode-online" className="flex items-start gap-5 border border-slate-800 p-8 hover:border-sky-400/60 transition-colors duration-500">
                        <Video size={28} className="text-sky-400 shrink-0 mt-1" strokeWidth={1.5} />
                        <div>
                            <h4 className="font-serif text-2xl text-slate-50">Online</h4>
                            <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                                Videochiamata con lavagna condivisa: stessa efficacia, zero spostamenti. Perfetta anche per le superiori.
                            </p>
                        </div>
                    </div>
                </Reveal>
                <Reveal delay={0.12}>
                    <div data-testid="mode-presenza" className="flex items-start gap-5 border border-slate-800 p-8 hover:border-sky-400/60 transition-colors duration-500">
                        <MapPin size={28} className="text-sky-400 shrink-0 mt-1" strokeWidth={1.5} />
                        <div>
                            <h4 className="font-serif text-2xl text-slate-50">A domicilio</h4>
                            <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                                Veniamo noi da te, a Livorno e dintorni. Carta, penna e calma: il metodo che non passa mai di moda.
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
export default Method;
